import { useContext } from 'react';
import { CtxConfigurator } from '~/app/pages/configurator/context/ctx-configurator/ctx-configurator';

export function useCtxConfigurator() {
	const ctx = useContext(CtxConfigurator);

	if (!ctx) throw new Error('useCtxConfigurator must be used within a CtxConfiguratorProvider');

	return ctx;
}
